import _ from 'lodash'
import { BaseDataItem, RefInfo } from '@wix/document-services-types'
import { Data, RefSchemas } from '@wix/thunderbolt-becky-types'
import { DataWithDrafts } from './dataResolvingTypes'
import { isDraftDataItem } from './dataResolvingUtils'

type FixerFunction = (refs: Array<RefInfo>) => Array<RefInfo>

const makeAllRefsNotWeak = (refs: Array<RefInfo>) => refs.map((ref) => ({ ...ref, isRefOwner: true }))
const schemaFixer: Record<string, FixerFunction> = {
	TinyMenu: makeAllRefsNotWeak,
	CustomMenuDataRef: makeAllRefsNotWeak,
	BreadcrumbsData: makeAllRefsNotWeak,
	MenuData: makeAllRefsNotWeak,
}

export const createRefInfo = (refInfo: Partial<RefInfo>): RefInfo => ({
	jsonPointer: '',
	refTypes: [],
	shouldCollect: false,
	shouldValidate: false,
	isRelationalSplit: false,
	isList: false,
	referencedMap: '',
	path: [],
	...refInfo,
})

const EMPTY_ARRAY: Array<RefInfo> = []

const builderWidgetRefResolver = (dataItem: BaseDataItem) => {
	return _.keys(dataItem).reduce((acc, key) => {
		if (!['id', 'type', 'metaData'].includes(key)) {
			acc.push(createRefInfo({ path: [key], referencedMap: 'innerElements', isRefOwner: true }))
		}
		return acc
	}, [] as Array<RefInfo>)
}

export const createSchemaManager = (schemas: RefSchemas) => {
	const sameMapRefs: RefSchemas = {}

	// Remove cross maps refs because in CARMI we can't resolve them (while in catharsis we do resolve them)
	const getSchemaByType = (mapName: keyof Data, dataType: string) => {
		if (!sameMapRefs[mapName]?.[dataType]) {
			sameMapRefs[mapName] = sameMapRefs[mapName] ?? {}
			const refs = schemas[`${mapName}.json`]?.[dataType]
			if (!refs) {
				sameMapRefs[mapName][dataType] = EMPTY_ARRAY
				return sameMapRefs[mapName][dataType]
			}

			const fixedRefs = schemaFixer[dataType]?.(refs) ?? refs
			sameMapRefs[mapName][dataType] = fixedRefs.filter((ref) => mapName === ref.referencedMap)
		}

		return sameMapRefs[mapName][dataType]
	}

	const getSchemaFromDataItem = (mapName: keyof Data, dataItem: DataWithDrafts | BaseDataItem) => {
		if (!dataItem) {
			return undefined
		}

		if (isDraftDataItem(dataItem)) {
			return dataItem._draftRefs?.filter(({ referencedMap }) => !referencedMap || referencedMap === mapName)
		}

		if (mapName === 'innerElements' && dataItem.type !== 'InnerElement') {
			return builderWidgetRefResolver(dataItem)
		}

		return getSchemaByType(mapName, dataItem.type)
	}

	return { getSchemaFromDataItem, getSchemaByType }
}
